// extracted by mini-css-extract-plugin
export var label = "_d6-2";
export var slideContainer = "_d6-0";
export var slider = "_d6-1";